import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import { Tv, Eye, EyeOff } from 'lucide-react';

export default function CustomerLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ mobile: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form, true); // isCustomer = true
      toast.success('Welcome to your account!');
      navigate('/portal');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
            <img src="/logo.png" alt="JagdishNet" style={{ height: 72, objectFit: 'contain' }} />
          </div>
          <h1>Jagdish<span>Net</span></h1>
          <p>Customer Self-Service Portal</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Registered Mobile Number</label>
            <input
              type="tel" className="form-control" placeholder="Your mobile number"
              value={form.mobile} onChange={e => setForm({ ...form, mobile: e.target.value })}
              required autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPass ? 'text' : 'password'} className="form-control"
                placeholder="Default: last 4 digits of STB serial"
                value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                style={{ paddingRight: 40 }} required
              />
              <button type="button" onClick={() => setShowPass(!showPass)}
                style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)' }}>
                {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            <p className="form-hint">Default password: last 4 digits of your STB serial number</p>
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div style={{ marginTop: 20, textAlign: 'center' }}>
          <Link to="/login" style={{ fontSize: '.82rem', color: 'var(--text-muted)', textDecoration: 'none' }}>
            ← Staff login
          </Link>
        </div>

        <p style={{ textAlign: 'center', fontSize: '.75rem', color: 'var(--text-light)', marginTop: 20 }}>
          For account issues, contact your ISP office.
        </p>
      </div>
    </div>
  );
}
